var makeString = require('./makeString');

module.exports = function adjacent(str, direction) {
  str = makeString(str);
  if (str.length === 0) {
    return '';
  }
  return str.slice(0, -1) + String.fromCharCode(str.charCodeAt(str.length - 1) + direction);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/helper/adjacent.js
 ** module id = 517
 ** module chunks = 0
 **/